module.exports = __webpack_public_path__ + "static/img/dashuju2x.e86c50c1.png";